// Shared one-time welcome toast helper for /overview. Each `dog_type` (and
// the `is_breeder` flag) gets its own localStorage gate so the toasts
// coexist without fighting. Wrapped in try/catch in case localStorage is
// blocked (private-mode Safari, embedded iOS WebViews, etc.).
import { useEffect } from "react";
import { toast } from "sonner";

export function useWelcomeToast({ shouldFire, storageKey, toastId, copy, duration = 8000 }) {
  useEffect(() => {
    if (!shouldFire) return;
    try {
      if (window.localStorage.getItem(storageKey) === "1") return;
      toast.success(copy, { duration, id: toastId });
      window.localStorage.setItem(storageKey, "1");
    } catch (err) {
      console.debug(`useWelcomeToast(${toastId}): localStorage blocked`, err);
    }
  }, [shouldFire, storageKey, toastId, copy, duration]);
}
